import BaseModel from './BaseModel'

export default class Designation extends BaseModel {
  // ... Designation-specific methods or overrides ...
}
